// Components==============
import { motion } from "framer-motion";
import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import styled from "styled-components";
// =========================

const Flex = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 130px;
`;

export default function Socials() {
  const data = useStaticQuery(graphql`
    query socialQuery {
      sanityDustMedia {
        socials {
          instagram
          linkedIn
          vimeo
        }
      }
    }
  `);

  const { vimeo, linkedIn, instagram } = data.sanityDustMedia?.socials;

  return (
    <Flex>
      <a href={vimeo} target="_blank" rel="noopener noreferrer">
        <svg
          width="30"
          height="28"
          viewBox="0 0 30 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <motion.path
            d="M29.5578 6.38227C29.4253 9.48476 27.415 13.7328 23.527 19.1264C19.5064 24.7586 16.1044 27.5747 13.3209 27.5747C11.5978 27.5747 10.1398 25.8564 8.94691 22.4198L6.56106 12.9691C5.67742 9.5325 4.7275 7.81419 3.71131 7.81419C3.4904 7.81419 2.71721 8.31537 1.39174 9.31772L0 7.38462C1.45801 6.00042 2.89393 4.61623 4.30775 3.23205C6.25176 1.41828 7.70976 0.463667 8.68177 0.3682C10.9792 0.12955 12.3931 1.82399 12.9232 5.45152C13.4976 9.36545 13.8952 11.7997 14.1162 12.7543C14.7789 16 15.5079 17.6229 16.3032 17.6229C16.9217 17.6229 17.8495 16.5728 19.0866 14.4727C20.3238 12.3725 20.9865 10.7735 21.0749 9.67572C21.2516 7.86195 20.5888 6.95507 19.0866 6.95507C18.3797 6.95507 17.6507 7.12213 16.8996 7.45625C18.3576 2.34905 21.1411 -0.132948 25.2501 0.0102531C28.2986 0.10572 29.7345 2.22974 29.5578 6.38232L29.5578 6.38227Z"
            initial={{ fill: "#fff" }}
            whileHover={{ fill: "#E1C598" }}
          />
        </svg>
      </a>
      <a href={linkedIn} target="_blank" rel="noopener noreferrer">
        <svg
          width="37"
          height="38"
          viewBox="0 0 37 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <motion.path
            d="M8.63284 37.3533V12.1511H0.844748V37.3533H8.63284ZM4.7398 8.70809C7.45565 8.70809 9.14613 6.77286 9.14613 4.35446C9.09553 1.88152 7.45575 0 4.79134 0C2.12734 0 0.385254 1.88156 0.385254 4.35446C0.385254 6.77297 2.07532 8.70809 4.68896 8.70809H4.7398ZM12.9435 37.3533H20.7316V23.2792C20.7316 22.5259 20.7822 21.7735 20.9879 21.235C21.5509 19.7301 22.8324 18.1714 24.9838 18.1714C27.8019 18.1714 28.9294 20.4826 28.9294 23.8705V37.3531H36.717V22.9024C36.717 15.1613 32.8747 11.5594 27.7507 11.5594C23.5493 11.5594 21.7046 14.0853 20.6798 15.8057H20.7318V12.1506H12.9437C13.0459 14.5154 12.9435 37.3533 12.9435 37.3533Z"
            initial={{ fill: "#fff" }}
            whileHover={{ fill: "#E1C598" }}
          />
        </svg>
      </a>
      <a href={instagram} target="_blank" rel="noopener noreferrer">
        <svg
          width="28"
          height="30"
          viewBox="0 0 28 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <motion.path
            d="M27.9102 8.75203C27.8946 7.52042 27.6756 6.30104 27.2629 5.14846C26.905 4.17627 26.3584 3.29334 25.658 2.55609C24.9576 1.81884 24.1188 1.24349 23.1952 0.866786C22.1143 0.439687 20.9723 0.208746 19.818 0.183799C18.3318 0.113874 17.8606 0.0943604 14.088 0.0943604C10.3153 0.0943604 9.83176 0.0943605 8.35637 0.183799C7.20258 0.20893 6.06118 0.439867 4.98076 0.866786C4.057 1.24322 3.21806 1.81849 2.51762 2.55577C1.81717 3.29305 1.27066 4.17611 0.913028 5.14846C0.506458 6.28536 0.287533 7.48706 0.265714 8.70162C0.199283 10.2676 0.179199 10.7636 0.179199 14.7347C0.179199 18.7057 0.179199 19.2131 0.265714 20.7677C0.288887 21.9841 0.506719 23.1842 0.913028 24.3241C1.27126 25.2962 1.81818 26.1789 2.51886 26.9159C3.21953 27.6528 4.05855 28.2278 4.9823 28.6042C6.05977 29.0484 7.20136 29.2959 8.35792 29.3359C9.84566 29.4059 10.3169 29.427 14.0895 29.427C17.8622 29.427 18.3457 29.427 19.8211 29.3359C20.9754 29.312 22.1174 29.0816 23.1983 28.6546C24.1216 28.2775 24.9602 27.7019 25.6606 26.9648C26.3609 26.2276 26.9077 25.3449 27.266 24.3729C27.6723 23.2346 27.8901 22.0345 27.9133 20.8165C27.9797 19.2521 27.9998 18.7562 27.9998 14.7835C27.9967 10.8124 27.9967 10.3083 27.9102 8.75203V8.75203ZM14.0787 22.2443C10.133 22.2443 6.93661 18.8797 6.93661 14.7265C6.93661 10.5733 10.133 7.20881 14.0787 7.20881C15.9729 7.20881 17.7895 8.00085 19.1289 9.4107C20.4683 10.8205 21.2208 12.7327 21.2208 14.7265C21.2208 16.7204 20.4683 18.6325 19.1289 20.0424C17.7895 21.4522 15.9729 22.2443 14.0787 22.2443V22.2443ZM21.505 8.68373C20.5827 8.68373 19.8396 7.89992 19.8396 6.93073C19.8396 6.70063 19.8827 6.47278 19.9664 6.2602C20.05 6.04761 20.1726 5.85445 20.3272 5.69175C20.4818 5.52904 20.6653 5.39998 20.8672 5.31192C21.0692 5.22387 21.2857 5.17855 21.5043 5.17855C21.7229 5.17855 21.9393 5.22387 22.1413 5.31192C22.3433 5.39998 22.5268 5.52904 22.6813 5.69175C22.8359 5.85445 22.9585 6.04761 23.0422 6.2602C23.1258 6.47278 23.1689 6.70063 23.1689 6.93073C23.1689 7.89992 22.4243 8.68373 21.505 8.68373Z"
            initial={{ fill: "#fff" }}
            whileHover={{ fill: "#E1C598" }}
          />
          <motion.path
            d="M14.0788 19.6099C16.641 19.6099 18.7181 17.4236 18.7181 14.7266C18.7181 12.0296 16.641 9.84326 14.0788 9.84326C11.5166 9.84326 9.43945 12.0296 9.43945 14.7266C9.43945 17.4236 11.5166 19.6099 14.0788 19.6099Z"
            initial={{ fill: "#fff" }}
            whileHover={{ fill: "#E1C598" }}
          />
        </svg>
      </a>
    </Flex>
  );
}
